import { SearchIcon } from '@heroicons/react/solid';
import React from 'react';

export function Subheader({
    leftContent,
    rightContent,
}: {
    leftContent?: React.ReactNode;
    rightContent?: React.ReactNode;
}) {
    return (
        <div className="static h-16 left-0 right-0 bg-white justify-between items-center px-4 w-full flex border-b border-gray-050 shadow-lg">
            <div className="flex h-full">{leftContent && leftContent}</div>
            <div className="flex justify-center items-center">{rightContent && rightContent}</div>
        </div>
    );
}
